/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({

  storeSearch: {
    name: 'store-search',
    componentName: 'SearchContainer',
    chunk: () => import(
      /* webpackChunkName: "store-search" */
      './pages/store-search/SearchContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-search/SearchContainer.js')).SearchContainer
        : currentRouteName === 'storesearch'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SearchContainer })))
    },
    path: '/:context?/l/search/:storeNumber',
    varnish: false,
    channel: 'desktop'
  },
  storeSearchMobile: {
    name: 'store-search-mobile',
    componentName: 'SearchMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "store-search-mobile" */
      './pages/store-search/SearchMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-search/SearchMobileContainer.js')).SearchMobileContainer
        : currentRouteName === 'storesearch'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SearchMobileContainer })))
    },

    path: '/:context?/l/search/:storeNumber/:coordinates',
    varnish: false,
    channel: 'mobile'
  },
  storeDetails: {
    name: 'store-details',
    componentName: 'DetailsContainer',
    chunk: () => import(
      /* webpackChunkName: "store-details" */
      './pages/store-details/DetailsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-details/DetailsContainer.js')).DetailsContainer
        : currentRouteName === 'storedetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DetailsContainer })))
    },
    path: [
      '/:context?/l/:name/:state/:city/:storeZip/:storeNumber',
      '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/reviews/:reviewPage?'
    ],
    varnish: true,
    channel: null
  },
  storeDirectory: {
    name: 'store-directory',
    componentName: 'DirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "store-directory" */
      './pages/store-directory/DirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/DirectoryContainer.js')).DirectoryContainer
        : currentRouteName === 'storedirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DirectoryContainer })))
    },
    path: '/:context?/l/storeDirectory',
    varnish: true,
    channel: null
  },
  stateDirectory: {
    name: 'state-directory',
    componentName: 'StateDirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "state-directory" */
      './pages/store-directory/StateDirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/StateDirectoryContainer.js')).StateDirectoryContainer
        : currentRouteName === 'statedirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StateDirectoryContainer })))
    },
    path: '/:context?/l/:state',
    varnish: true,
    channel: null
  },

  homeServices: {
    name: 'homeservices',
    componentName: 'HomeServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "homeservices" */
      './pages/home-services/HomeServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/home-services/HomeServicesContainer.js')).HomeServicesContainer
        : currentRouteName === 'homeservices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/services',
    varnish: true,
    channel: null
  },

  rentalServices: {
    name: 'rentalservices',
    componentName: 'RentalServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "rentalservices" */
      './pages/rental-services/RentalServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/rental-services/RentalServicesContainer.js')).RentalServicesContainer
        : currentRouteName === 'rentalservices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RentalServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/rentals',
    varnish: true,
    channel: null
  },

  searchLoader: {
    name: 'searchloader',
    componentName: 'SearchLoader',
    chunk: () => import(
      /* webpackChunkName: "searchloader" */
      './pages/SearchLoader'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SearchLoader.js')).SearchLoader
        : currentRouteName === 'searchloader'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SearchLoader })))
    },
    path: '/:context?/l/',
    channel: null
  }
});
